import { render, staticRenderFns } from "./CandidateFiltersChips.vue?vue&type=template&id=cb81f07e&lang=pug"
import script from "./CandidateFiltersChips.vue?vue&type=script&lang=js"
export * from "./CandidateFiltersChips.vue?vue&type=script&lang=js"
import style0 from "./CandidateFiltersChips.vue?vue&type=style&index=0&id=cb81f07e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports